const progress = {
  state: {
    userCode: '', // 进度点击某一行的评价次数当前行的userCode
    defaultForm: '' // 表格上面的筛选条件
  },
  mutations: {
    SET_USERCODE: (state, list) => {
      state.userCode = list
    },
    SET_DEFAULTFORM: (state, list) => {
      state.defaultForm = list
    }
  },
  actions: {
    getUserCode ({
      commit
    }, list) {
      commit('SET_USERCODE', list)
    },
    getDefaultForm ({
      commit
    }, list) {
      commit('SET_DEFAULTFORM', list)
    }
  }
}

export default progress



// WEBPACK FOOTER //
// ./src/store/modules/progress.js